import type { RgbMovementType, RgbRefugoMotivo } from "./api/rgbApi";

/** Rótulos locais — o backend também os manda em `/rgb/config`, mas a lista precisa deles sem config. */
export const TYPE_LABELS: Record<RgbMovementType, string> = {
  RECEBIMENTO: "Recebimento",
  DEVOLUCAO_CDD: "Devolução ao CDD",
  REFUGO: "Refugo",
  AJUSTE_SALDO: "Ajuste de saldo",
};

export const MOTIVO_LABELS: Record<RgbRefugoMotivo, string> = {
  QUEBRA: "Quebra",
  TRINCA: "Trinca",
  BOCA_LASCADA: "Boca lascada",
  DESGASTE: "Desgaste",
  SUJIDADE: "Sujidade",
  FORA_DE_PADRAO: "Fora de padrão",
  OUTRO: "Outro",
};

export const TYPE_BADGE: Record<RgbMovementType, string> = {
  REFUGO: "rgbBadge--red",
  RECEBIMENTO: "rgbBadge--green",
  DEVOLUCAO_CDD: "rgbBadge--blue",
  AJUSTE_SALDO: "rgbBadge--orange",
};

const pad = (n: number) => String(n).padStart(2, "0");

/** Hoje como data civil em São Paulo, 'YYYY-MM-DD' — mesma régua do backend. */
export const todayIso = (): string =>
  new Date().toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });

/** Mês corrente em 'YYYY-MM' (valor de `<input type="month">`). */
export const currentMonth = (): string => todayIso().slice(0, 7);

/** 'YYYY-MM' → primeiro e último dia do mês. */
export const monthRange = (month: string): { startDate: string; endDate: string } => {
  const [y, m] = month.split("-").map(Number);
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return { startDate: `${y}-${pad(m)}-01`, endDate: `${y}-${pad(m)}-${pad(last)}` };
};

/** Desloca 'YYYY-MM' em N meses. */
export const shiftMonth = (month: string, delta: number): string => {
  const [y, m] = month.split("-").map(Number);
  const d = new Date(Date.UTC(y, m - 1 + delta, 1));
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}`;
};

/** 'YYYY-MM-DD' → 'dd/mm/aaaa' sem passar por Date (evita o dia anterior no fuso -3). */
export const formatDateBr = (iso: string): string => {
  const [y, m, d] = iso.slice(0, 10).split("-");
  return y && m && d ? `${d}/${m}/${y}` : iso;
};

/** Timestamp ISO → dia civil em São Paulo, 'YYYY-MM-DD'. */
export const isoToLocalDay = (iso: string): string =>
  new Date(iso).toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });

export const formatInt = (n: number | null | undefined): string =>
  n === null || n === undefined ? "—" : n.toLocaleString("pt-BR");

export const formatPercent = (n: number | null | undefined): string =>
  n === null || n === undefined ? "—" : `${n.toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;
